module.exports = __webpack_public_path__ + "@/assets/img/006-girl-3.598b165f.svg";